import { ShieldX } from 'lucide-react';

import SecurityLayout from '../../components/security/SecurityLayout';

import { SUPPORT } from '../../config/support';

export default function BlockedPage() {
  return (
    <SecurityLayout
      variant="blocked"
      icon={ShieldX}
      title="Conta bloqueada"
      description="O acesso à plataforma foi restringido pela administração da Nexora."
      buttonText="Falar com o suporte"
      buttonHref={SUPPORT.whatsapp}
      footerText="Caso considere esta decisão incorreta, entre em contato com nossa equipe."
    />
  );
}